/** Query param used to carry the booking-host anon id across to platform magic-link completion. */
export const PH_DISTINCT_ID_QUERY_PARAM = 'ph_distinct_id';

/**
 * `new URL()` needs an absolute base to parse path-only redirects (`/explore-venues?…`).
 * We use the current origin, then return only pathname/search/hash — the host is never kept.
 */
const redirectParseBase = (): string => window.location.origin;

/** Append (or replace) `ph_distinct_id` on a same-origin redirect path. */
export const appendPostHogDistinctIdToRedirectUrl = (redirectUrl: string, distinctId: string): string => {
    if (!distinctId) {
        return redirectUrl;
    }

    try {
        const url = new URL(redirectUrl, redirectParseBase());
        url.searchParams.set(PH_DISTINCT_ID_QUERY_PARAM, distinctId);
        return `${url.pathname}${url.search}${url.hash}`;
    } catch {
        return redirectUrl;
    }
};

/** Pull `ph_distinct_id` out of a redirect path so it is not left in the post-auth navigation URL. */
export const extractPostHogDistinctIdFromRedirect = (
    redirect: string
): { distinctId?: string; cleanRedirect: string } => {
    try {
        const url = new URL(redirect, redirectParseBase());
        const distinctId = url.searchParams.get(PH_DISTINCT_ID_QUERY_PARAM) || undefined;
        if (!distinctId) {
            return { cleanRedirect: redirect };
        }

        url.searchParams.delete(PH_DISTINCT_ID_QUERY_PARAM);
        const cleanRedirect = `${url.pathname}${url.search}${url.hash}`;
        return { distinctId, cleanRedirect };
    } catch {
        return { cleanRedirect: redirect };
    }
};
